import { put, select } from 'redux-saga/effects';
import {
  manualModeChangesDiscarded,
  updateTabSharedChanges,
} from '../../sheetsManagerSlice';
import { syncTabChanges, tabSyncManualModeDiscardChanges } from './syncActions';
import { RootState } from '../../../../core/redux/store';
import { PartialSheetViews, Sheets } from '../../../types';
// import { updateDependentSheetViewports } from '../rootDeprecated/root';

export function* tabSyncDiscardManualModeChangesMi({
  payload: updates,
}: ReturnType<typeof tabSyncManualModeDiscardChanges>) {
  const updatedSheetViews: PartialSheetViews = {};
  // yield updateDependentSheetViewports(
  //   '',
  //   updates.updatedSheets,
  //   updatedSheetViews
  // );

  console.log('recceived -- updates', updates);

  yield put(
    manualModeChangesDiscarded({
      ...updates,
      updatedSheetViews,
    })
  );
}

export function* syncTabChangesMi({
  payload,
}: ReturnType<typeof syncTabChanges>) {
  const thisUserId: string = yield select(
    (state: RootState) => state.auth.user.id
  );
  const sheets: Sheets = yield select(
    (state: RootState) => state.sheetsManager.sheets
  );

  const { userId, ...updates } = payload;

  if (thisUserId !== userId) {
    // TODO: Delete filters from sheet If filters are not shared
    updates.updatedSheetsIdToName = undefined;
    updates.updatedGroups = undefined;
    for (let sheetId in updates.updatedSheets) {
      if (!sheets[sheetId]) delete updates.updatedSheets[sheetId];
    }
    updates.present = {};
  }
  const updatedSheetViews: PartialSheetViews = {};

  // yield updateDependentSheetViewports(
  //   '',
  //   updates.updatedSheets,
  //   updatedSheetViews
  // );

  // console.log('updates', updates);

  //   console.log("updatedSheetViews", updatedSheetViews)

  yield put(
    updateTabSharedChanges({
      ...updates,
      updatedSheetViews,
    })
  );
}
